import * as React     from 'react';
import PropTypes      from 'prop-types';
import InputContainer from './input-container';

export default class RadioContainer extends React.Component {
	render() {
		return <InputContainer {...this.props} type="radio" />;
	}
}

RadioContainer.propTypes = {
	checked       : PropTypes.bool,
	disabled      : PropTypes.bool,
	id            : PropTypes.string,
	label         : PropTypes.string,
	loading       : PropTypes.bool,
	max           : PropTypes.number,
	min           : PropTypes.number,
	name          : PropTypes.string.isRequired,
	placeholder   : PropTypes.string,
	required      : PropTypes.bool,
	step          : PropTypes.number,
	value         : PropTypes.oneOfType([
		PropTypes.bool,
		PropTypes.number,
		PropTypes.string
	])
}


// WEBPACK FOOTER //
// ./src/component/form/input/radio-container.js